<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :height="300"
    size="mini"
    resizable
    border
    :header-cell-style="
      () => {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    "
  >
    <template v-slot:top>
      <slot name="header"> </slot>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
}
</script>
